var themeVars = require("./variables");

module.exports = {

    /**
     * Vertical padding of title in rem.
     *
     * @type {number}
     * @public
     */
    titlePaddingTb: 0.5,

    /**
     * Get the vertical padding of title in pixels.
     *
     * @return {number}  The padding in pixels
     * @public
     */
    getTitlePaddingTbPx: function() {
        return this.titlePaddingTb * themeVars.remToPx;
    },

    /**
     * The height of the title area in pixels
     *
     * @return {number}  The height in pixels
     * @public
     */
    getTitleHeightPx: function() {
        var padding    = this.getTitlePaddingTbPx(),
            lineHeight = themeVars.headerLineHeight * themeVars.remToPx;

        return padding + lineHeight * themeVars.fontSizeSmall + padding;
    }

};
